<!-- Navigation loading -->
@if (isNavigating()) {
  <rocket-loading-overlay />
}

<router-outlet />
